import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import Icon from '../../../components/AppIcon';


export default function StatsWidget({ title, value, icon: Icon, color = 'blue', trend, trendValue }) {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    purple: 'bg-purple-50 text-purple-600',
    red: 'bg-red-50 text-red-600',
    yellow: 'bg-yellow-50 text-yellow-600'
  };

  const borderColors = {
    blue: 'border-blue-100',
    green: 'border-green-100',
    purple: 'border-purple-100',
    red: 'border-red-100',
    yellow: 'border-yellow-100'
  };

  return (
    <div className={`bg-white rounded-lg shadow-sm border ${borderColors?.[color]} p-6`}>
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-lg ${colorClasses?.[color]}`}>
          <Icon className="w-6 h-6" />
        </div>
        {trend && trendValue && (
          <div className={`flex items-center gap-1 text-sm font-medium ${
            trend === 'up' ? 'text-green-600' : 'text-red-600'
          }`}>
            {trend === 'up' ? (
              <TrendingUp className="w-4 h-4" />
            ) : (
              <TrendingDown className="w-4 h-4" />
            )}
            {trendValue}%
          </div>
        )}
      </div>
      <div>
        <h3 className="text-2xl font-bold text-gray-900 mb-1">
          {typeof value === 'number' ? value?.toLocaleString() : value}
        </h3>
        <p className="text-sm text-gray-600">{title}</p>
      </div>
    </div>
  );
}